<template>
  <div class="notification__admin">
    <div class="notification__header">
      <p class="notification__title">
        {{ lastItem.title }}
      </p>
      <span
        class="notification__close"
        @click="hideNotification">x</span>
    </div>
    <div class="notification__body admin-notification-body">
      <div class="notification__message">
        {{ lastItem.message }}
      </div>
      <template v-if="lastItem.link">
        <router-link
          :to="`/admin/${lastItem.link.entity}s/${lastItem.link.id}`">
          <div
            class="admin-button admin-button--blue notification-button"
            @click="hideNotification">
            {{ lastItem.link.text }}
          </div>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationsItemAdmin',

  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  computed: {
    lastItem() {
      return this.notification.items[this.notification.items.length - 1];
    },
  },

  mounted() {
    setTimeout(() => {
      this.hideNotification();
    }, 5000);
  },

  methods: {
    hideNotification() {
      this.$emit('hide', this.notification.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-notification-body {
  display: block!important;
  a {
    display: flex;
    justify-content: center;
  }
}
</style>
